export default {

  /** 新增巡查记录 */
  insertPaInspectTask: '/ygsjzs/paInspectTask/insertPaInspectTask',
  /** 物理删除巡查记录 */
  deleteDataPaInspectTask: '/ygsjzs/paInspectTask/deleteDataPaInspectTask',
  /** 查询巡查记录详情 */
  selectPaInspectTaskByTaskId: '/ygsjzs/paInspectTask/selectPaInspectTaskByTaskId',
  /** 按日期查询巡查记录统计 */
  selectPaInspectTaskDayByPage: '/ygsjzs/paInspectTask/selectPaInspectTaskDayByPage',
  /** 查询巡查记录列表 */
  selectPaInspectTaskByPage: '/ygsjzs/paInspectTask/selectPaInspectTaskByPage'
}
